import React from 'react';
import { connect } from 'react-redux';
import {
  selectLinkedSourceById,
  getSelectedFlow,
  selectLinkedTargetById,
  selectLinkedConnectorById,
} from '../redux/selectors';
import EntityConfig from '../components/connectParams/EntityConfig';
import { fetchLinkedConnector, fetchLinkedSource, link } from '../redux/actions';
import sortByTenantIdFn from '../utils/sortByTenantId';

const EntityConfigWrapper = (props) => {
  return <EntityConfig {...props} />;
};

const mapStateToProps = (state, props) => {
  const {
    configuration: { tenant_id, connectionName, nextStep, listener, hideBackButtons, localization },
    preferences: { multipleTenantLinks, featureFlags },
    entities: { selectedEntity },
    sources: { linkedList: sourceLinkedList },
    targets: { linkedList: targetLinkedList },
    connectors: { linkedList: connectorsLinkedList },
    flows: { selectedFlow },
  } = state;

  const subtenantDelimiter = featureFlags?.subtenantDelimiter ?? '_';

  const linkList = (
    selectedEntity.entityType === 'source'
      ? sourceLinkedList
      : selectedEntity.entityType === 'connector'
      ? connectorsLinkedList
      : targetLinkedList
  )
    .filter((linked) => {
      if (selectedEntity.entityType === 'source') return linked.tap === selectedEntity.tap;
      else return linked.id === selectedEntity.id;
    })
    .sort(sortByTenantIdFn(tenant_id, subtenantDelimiter));
  let linkedSource =
    selectedEntity && selectedEntity.entityType === 'source' && selectLinkedSourceById(selectedEntity.tap);
  let linkedTarget =
    selectedEntity && selectedEntity.entityType === 'target' && selectLinkedTargetById(selectedEntity.target);
  let linkedConnector =
    selectedEntity && selectedEntity.entityType === 'connector' && selectLinkedConnectorById(selectedEntity.id);

  if (linkList?.length > 0) {
    if (selectedEntity.entityType === 'source')
      linkedSource = linkList.find((x) => x.tenant_id === selectedEntity.tenant_id);
    if (selectedEntity.entityType === 'target')
      linkedTarget = linkList.find((x) => x.tenant_id === selectedEntity.tenant_id);
    if (selectedEntity.entityType === 'connector')
      linkedConnector = linkList.find((x) => x.tenant_id === selectedEntity.tenant_id);
  }

  return {
    connectParams: state.configuration.connectParams,
    entity: selectedEntity,
    listener,
    linkedSource,
    linkedTarget,
    linkedConnector,
    isConnected:
      (state.targets.selectedTarget && state.targets.selectedTarget.target === selectedEntity.target) ||
      (state.sources.selectedSource && state.sources.selectedSource.tap === selectedEntity.tap) ||
      (state.connectors.selectedConnector && state.connectors.selectedConnector.id === selectedEntity.id),
    flowId: getSelectedFlow(),
    tenantId: tenant_id,
    flow: selectedFlow,
    linkList,
    multipleTenantLinks: multipleTenantLinks ?? false,
    connectionName,
    nextStep,
    hideBackButtons,
    localization,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchLinkedSource: (tap, tenantId) => dispatch(fetchLinkedSource(tap, false, tenantId)),
    fetchLinkedConnector: (id, tenantId) => dispatch(fetchLinkedConnector(id, false, undefined, tenantId)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EntityConfigWrapper);
